import { MapPin, Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer({ content = {} }) {
  return (
    <footer data-testid="footer" className="bg-primary text-primary-foreground">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <h3 className="font-serif text-3xl mb-4">Imassasje</h3>
            <p className="text-primary-foreground/70 text-sm leading-relaxed max-w-xs">
              Profesjonell avspenningsmassasje i rolige og behagelige omgivelser.
            </p>
          </div>
          <div>
            <h4 className="font-sans text-sm tracking-wide uppercase mb-4 text-primary-foreground/60">Kontakt</h4>
            <div className="space-y-3 text-sm">
              <a href={`tel:${content.contact_phone || ""}`} data-testid="footer-phone" className="flex items-center gap-3 text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                <Phone size={16} /> {content.contact_phone || "+47 123 45 678"}
              </a>
              <a href={`mailto:${content.contact_email || ""}`} data-testid="footer-email" className="flex items-center gap-3 text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                <Mail size={16} /> {content.contact_email || "hei@IMassasje.no"}
              </a>
              <p data-testid="footer-address" className="flex items-center gap-3 text-primary-foreground/80">
                <MapPin size={16} /> {content.contact_address || "Storgata 1, 0001 Oslo"}
              </p>
            </div>
          </div>
          <div>
            <h4 className="font-sans text-sm tracking-wide uppercase mb-4 text-primary-foreground/60">Snarveier</h4>
            <div className="space-y-3 text-sm">
              <Link to="/bestill" data-testid="footer-book-link" className="block text-primary-foreground/80 hover:text-primary-foreground transition-colors">Book time</Link>
              <Link to="/admin" data-testid="footer-admin-link" className="block text-primary-foreground/80 hover:text-primary-foreground transition-colors">Admin</Link>
            </div>
          </div>
        </div>
        <div className="border-t border-primary-foreground/20 mt-12 pt-8 text-center text-xs text-primary-foreground/50">
          &copy; {new Date().getFullYear()} Imassasje. Alle rettigheter reservert.
        </div>
      </div>
    </footer>
  );
}
